// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective {
  display: none;
}

.custom-select-wrapper {
  margin-top: 8px;
}

.input {
  display: inline-block;
}

.button-row {
  justify-content: center;
  display: grid;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-colum {
  display: flex;
  align-items: center;
}

.lossMonthlyCurrentLimit {
  white-space: nowrap;
}

.lossDelete {
  display: none;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/set-loss-limits/set-loss-limits.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAGI;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;AAAR;;AAGI;EACI,cAAA;AAAR;;AAGI;EACI,oBAAA;AAAR;;AAGI;EACI,aAAA;AAAR;;AAGI;EACI,eAAA;AAAR;;AAGI;EACI,qBAAA;AAAR;;AAGI;EACI,uBAAA;EACA,aAAA;AAAR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,aAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;AADR;;AAII;EACI,aAAA;AADR;;AAII;EACI,kBAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,SAAA;EACA,WAAA;EACA,mBAAA;AADR","sourcesContent":["\r\n    ion-select.select {\r\n        margin: 0px;\r\n    }\r\n    \r\n    .row {\r\n        align-items: center;\r\n        white-space: nowrap;\r\n        display: flex;\r\n    }\r\n\r\n    .red {\r\n        color: #d3001d;\r\n    }\r\n\r\n    .globalLimit {\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective {\r\n        display: none;\r\n    }\r\n\r\n    .custom-select-wrapper {\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .input {\r\n        display: inline-block;\r\n    }\r\n\r\n    .button-row {\r\n        justify-content: center;\r\n        display: grid;\r\n        \r\n    }\r\n\r\n    .deposit-column {\r\n        flex-direction: row;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .label-colum {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .lossMonthlyCurrentLimit {\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .lossDelete {\r\n        display: none\r\n    }\r\n\r\n    .label-text {\r\n        text-overflow: \"-\";\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .deposit-column {\r\n        flex-direction: row;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    \r\n    hr {\r\n        border: 0;\r\n        height: 1px;\r\n        background: #C2C2C2;\r\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
